import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#0a6eb4',
    },
    text: {
      primary: '#191a19',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: ['Open Sans', 'sans-serif'].join(','),

    h1: {
      fontSize: '3.052em',
    },
    h2: {
      fontSize: '2.441em',
    },
    h3: {
      fontSize: '1.953em',
    },
    h4: {
      fontSize: '1.563em',
    },
    h5: {
      fontSize: '1.25em',
    },
  },
  overrides: {},
});
